<template>
  <div class="parlay-free">
    <template v-if="showFree">
      <ParlayInfo @show="show" @changeView="changeView" />
    </template>
    <template v-if="showDesglose">
      <ParlayDesglose @show="show" :isTips="true" @changeView="changeView" />
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: 'GMakingMoney',
  components: {
    ParlayInfo: () => import('@/components/Sections/GolTipster-v2/General/ParlayInfoPremium'),
    ParlayDesglose: () => import('@/components/Sections/GolTipster-v2/General/ParlayDesglose'),
  },
  data() {
    return { showDesglose: true, showFree: false };
  },

  computed: {
    ...mapState(['displayWidth']),
    isMobile() {
      return this.displayWidth < 464;
    },
  },
  watch: {},
  methods: {
    ...mapActions('betsGeneral', ['getParlayFree']),
    changeView(opt) {
      if (opt == 'free') {
        this.showDesglose = false;
        this.showFree = true;
      } else {
        this.showDesglose = true;
        this.showFree = false;
      }
    },
    show() {
      this.showDesglose = !this.showDesglose;
      this.$emit('show');
    },
  },
  async created() {
    await this.getParlayFree();
  },
};
</script>

<style scoped lang="scss"></style>
